export var PIECE_TYPE;
(function (PIECE_TYPE) {
    PIECE_TYPE[PIECE_TYPE["CORNER"] = 0] = "CORNER";
    PIECE_TYPE[PIECE_TYPE["EDGE"] = 1] = "EDGE";
    PIECE_TYPE[PIECE_TYPE["MIDDLE"] = 2] = "MIDDLE";
})(PIECE_TYPE || (PIECE_TYPE = {}));
